exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Quicksand);", ""]);

// module
exports.push([module.id, "body{font-family:Quicksand,sans-serif}.price{list-style-type:none;margin:20px;-webkit-transition:margin .5s ease-out;-moz-transition:margin .5s ease-out;-o-transition:margin .5s ease-out;padding-left:0;min-width:180px}.basic-border{border:1px solid grey}.highlighted-border{border:1px solid #f44336}.price:hover{margin-top:10px}.price .highlighted-header{background-color:#f44336;color:#fff}.price .basic-header,.price .highlighted-header{font-size:24px;padding-top:15px;padding-bottom:15px}.price .basic-header{background-color:#f8f9fa;color:grey}.price li{padding:5px;text-align:center;font-size:14px}.price .tag{font-size:20px}.button-submit,.price .tag{margin-top:10px;margin-bottom:10px}.button-submit{background-color:#f44336;color:#fff;height:35px;border:none;font-size:11px;cursor:pointer}.text-line-through{text-decoration:line-through}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/index.css
// module id = 26
// module chunks = 0